jQuery(function ($) {
    const $roots = $('.spraga-variation-search.vs-root');
    if (!$roots.length) return;

    const instances = [];

    function escapeRegExp(str) {
        return String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function escapeHtml(str) {
        return $('<div/>').text(String(str || '')).html();
    }

    function highlightText(text, query) {
        const q = String(query || '').trim();
        if (!q) return escapeHtml(text);

        const tokens = q.split(/\s+/).filter(Boolean);
        if (!tokens.length) return escapeHtml(text);

        let out = escapeHtml(text);

        tokens.forEach((token) => {
            // optional: ignore 1-char tokens if you want less "noise"
            // if (token.length < 2) return;

            const re = new RegExp('(' + escapeRegExp(token) + ')', 'ig');
            out = out.replace(re, '<strong>$1</strong>');
        });

        return out;
    }

    function initSearchInstance($root) {
        // Prevent double init
        if ($root.data('vs-inited')) return;
        $root.data('vs-inited', true);

        const ajaxUrl = $root.data('ajax-url');
        const $input = $root.find('.vs-input');
        const $results = $root.find('.vs-results');

        let xhr = null;
        let t = null;

        function closeResults() {
            $results.prop('hidden', true).empty();
            $root.removeClass('is-open');
        }

        function openResults() {
            $results.prop('hidden', false);
            $root.addClass('is-open');
        }

        function render(items, q) {
            const clearBtn = `
                <button type="button" class="vs-clear" data-vs-clear>
                    Clear your search history
                </button>
            `;

            if (!items || !items.length) {
                $results.html(`
                    <div class="vs-head">${clearBtn}</div>
                    <div class="vs-empty">No results</div>
                `);
                openResults();
                return;
            }

            const isPopup = $root.hasClass('vs-popup');

            const html = items
                .map((it) => {
                    const url = it.url;

                    const titleRaw = it.title || '';
                    const variationRaw = it.variation || '';

                    if (isPopup) {
                        // Mobile: "Title (Variation)" in one line, no image
                        const combined = variationRaw ? `${titleRaw} (${variationRaw})` : titleRaw;
                        const combinedHtml = highlightText(combined, q);

                        return `
                            <a class="vs-item" href="${url}">
                                <span class="vs-title">${combinedHtml}</span>
                            </a>
                        `;
                    }

                    // Desktop: image + title + small variation (as you have now)
                    const img = it.img;
                    const titleHtml = highlightText(titleRaw, q);
                    const variationHtml = variationRaw ? highlightText(variationRaw, q) : '';

                    return `
                        <a class="vs-item" href="${url}">
                            <img class="vs-img" src="${img}" alt="" loading="lazy">
                            <span class="vs-text">
                                <span class="vs-title">${titleHtml}</span>
                                ${variationHtml ? `<small class="vs-variation">${variationHtml}</small>` : ``}
                            </span>
                        </a>
                    `;
                })
                .join('');

            $results.html(`
                <div class="vs-head">${clearBtn}</div>
                <div class="vs-list">${html}</div>
            `);

            openResults();
        }

        // Clear button click
        $root.on('click.vs', '[data-vs-clear]', function (e) {
            e.preventDefault();
            $input.val('');
            closeResults();
        });


        function search(q) {
            if (xhr) xhr.abort();

            xhr = $.ajax({
                url: ajaxUrl,
                method: 'GET',
                dataType: 'json',
                data: {
                    action: 'spraga_variation_search',
                    q: q,
                    limit: 10,
                },
            })
                .done(function (res) {
                    const items = res && res.success && res.data && res.data.items ? res.data.items : [];
                    render(items, q);
                })
                .fail(function () {
                    // ignore abort errors
                });
        }

        $input.on('keydown.vs', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
            }
            if (e.key === 'Escape') {
                closeResults();
                $input.blur();
            }
        });

        $input.on('input.vs focus.vs', function (e) {
            const raw = String($input.val() || '');
            const val = raw.trim();

            if (val.length === 0) {
                closeResults();
                return;
            }

            if (e.type === 'focus') {
                return;
            }

            if (val.length < 1) {
                return;
            }

            clearTimeout(t);
            t = setTimeout(function () {
                search(val);
            }, 200);
        });

        instances.push({
            $root,
            closeResults,
            $input,
            $results,
        });
    }

    // Init all instances (header + popup)
    $roots.each(function () {
        initSearchInstance($(this));
    });

    // Close results on outside click (for all instances)
    // $(document).on('click.vs', function (e) {
    //     const isInsideAny = $(e.target).closest('.spraga-variation-search.vs-root').length > 0;
    //     if (isInsideAny) return;
    //
    //     instances.forEach((inst) => inst.closeResults());
    // });

    /**
     * Mobile popup logic
     * Requirements:
     *  - Popup container: #mobile-search-popup
     *  - Close button: .mobile-search-popup-close (optional)
     *  - Trigger (one of):
     *      a[href="#mobile-search"]
     *      .mobile-search-trigger
     *      [data-mobile-search-open]
     */
    const $popup = $('#mobile-search-popup');

    function openMobileSearchPopup() {
        if (!$popup.length) return;

        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        $popup.addClass('is-open');
        $('html').addClass('overflow-hidden');

        // Focus popup input
        const $popupInput = $popup.find('.spraga-variation-search.vs-root .vs-input').first();
        if ($popupInput.length) {
            setTimeout(function () {
                $popupInput.trigger('focus');
            }, 50);
        }
    }

    function closeMobileSearchPopup() {
        if (!$popup.length) return;

        $popup.removeClass('is-open');
        $('html').removeClass('overflow-hidden');
    }

    function hardCloseMobileSearchPopup() {
        if (!$popup.length) return;

        const $popupRoot = $popup.find('.spraga-variation-search.vs-root').first();
        const popupInstance = instances.find((inst) => inst.$root.get(0) === $popupRoot.get(0));

        if (popupInstance) {
            popupInstance.$input.val('');

            popupInstance.closeResults();
        }

        $popup.removeClass('is-open');
        $('html').removeClass('overflow-hidden');
    }


    // Open popup
    $(document).on('click', 'a[href="#mobile-search"], .mobile-search-trigger, [data-mobile-search-open]', function (e) {
        e.preventDefault();
        openMobileSearchPopup();
    });

    // Close popup: click on backdrop OR close button
    $(document).on('click', '#mobile-search-popup', function (e) {
        if (e.target === this) {
            closeMobileSearchPopup();
            return;
        }

        if ($(e.target).closest('.mobile-search-popup-close').length) {
            hardCloseMobileSearchPopup();
        }
    });

    // Close popup: ESC
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $popup.length && $popup.hasClass('is-open')) {
            closeMobileSearchPopup();
        }
    });
});
